var $123a3e7569e58719$exports = {};
$123a3e7569e58719$exports = {
    "colorSwatchPicker": `F\xe4rgrutor`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe4lj en artikel`,
    "tableResizer": `Storleks\xe4ndrare`
};


export {$123a3e7569e58719$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
